import stopCampaignModal from './stopCampaignModal'

export default {
  stopCampaignModal,
}
